var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAssetClassificationHide = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5,0l5,5l-5,5L0,5L5,0z M7.4131,15.1504l6.7118-6.7118l0.8496,0.8496L8.2627,16L7.4131,15.1504z M8.0099,14.1417 l0.6608-0.6608c-0.515-0.2944-0.9326-0.7329-1.2015-1.2616c0.8072-1.2845,2.2079-2.0752,3.7247-2.1027 c0.2419-0.0099,0.484,0.0103,0.7209,0.0601l0.781-0.781c-0.4911-0.1226-0.9957-0.1832-1.5019-0.1802 c-2.047-0.0085-3.9167,1.1601-4.8061,3.0038C6.7581,12.9864,7.316,13.6476,8.0099,14.1417z M14.438,10.2968l-0.6608,0.6608 c0.4832,0.3332,0.8923,0.7627,1.2015,1.2616c-0.8088,1.2828-2.2085,2.073-3.7247,2.1027c-0.2631-0.0194-0.5242-0.0595-0.781-0.1202 l-0.781,0.781c1.2744,0.3811,2.6451,0.2741,3.8449-0.3004c1.0691-0.5284,1.9347-1.394,2.4631-2.4631 C15.6321,11.4682,15.0979,10.8108,14.438,10.2968z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAssetClassificationHide);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/asset-classification-hide.ea8dad90531605b75926aed23f6cc421.svg";